module.exports = __webpack_public_path__ + "static/img/img7.311f623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img7.png
// module id = n7xs
// module chunks = 1